import { render, staticRenderFns } from "./LCAGridView.vue?vue&type=template&id=a624d75e&scoped=true&"
import script from "./LCAGridView.vue?vue&type=script&lang=js&"
export * from "./LCAGridView.vue?vue&type=script&lang=js&"
import style0 from "./LCAGridView.vue?vue&type=style&index=0&id=a624d75e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a624d75e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
